import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/templates/Login.vue'
import PedidosVue from '@/pages/PedidosVue'
import ClientesVue from '@/pages/ClientesVue'
import HomeVue from '@/pages/HomeVue'
import CatalogoVue from '@/pages/CatalogoVue'
import RelatoriosVue from '@/pages/RelatoriosVue'
import StaticLayout from '../templates/StaticLayout'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login
    },
    {
      path: '/',
      component: StaticLayout,
      children: [
        {
          path: '/home',
          name: 'home',
          component: HomeVue
        },
        {
          path: '/pedidos',
          name: 'pedidos',
          component: PedidosVue
        },
        {
          path: '/clientes',
          name: 'clientes',
          component: ClientesVue
        },
        {
          path: '/relatorios',
          name: 'relatorios',
          component: RelatoriosVue
        },
        {
          path: '/catalogo',
          name: 'catalogo',
          component: CatalogoVue
        }
      ]
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js